<template>
	<div>
		<!-- Cabecera aviso privacidad -->
		<pm-header-aviso-privacidad></pm-header-aviso-privacidad>

		<!-- Aviso de privacidad -->
		<pm-aviso-privacidad></pm-aviso-privacidad>

		<!-- Pie pagina -->
		<pm-pie-pagina></pm-pie-pagina>
	</div>
</template>

<script>
	import PmHeaderAvisoPrivacidad from "@/components/publica/HeaderAvisoPrivacidad"
	import PmAvisoPrivacidad from "@/components/publica/AvisoPrivacidad"
	import PmPiePagina from "@/components/publica/PiePagina"
	export default {
		components: {
			PmHeaderAvisoPrivacidad,
			PmAvisoPrivacidad,
			PmPiePagina
		},
		mounted() {
			//this.ocultarChat()
		}
	}
</script>

<style scoped>
</style>